import React, { Component } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import "./App.scss";

import Demo from "./components/Demo";
import Archive, { loader as archiveLoader } from "./components/Archive";
import { loader as requestFromIdLoader } from "./components/Archive/RequestPanel";
import { action as destroyRequestAction } from "./components/Archive/DeleteButton";
import ErrorFallback from "./errors/error-boundary";
import RequireAuth from "./components/auth/RequireAuth";
import Login from "./components/auth/login";
import NotFoundPage from "./errors/not-found-page";

const router = createBrowserRouter([
  {
    path: "/login",
    element: (
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Login />
      </ErrorBoundary>
    ),
  },
  {
    path: "/",
    element: (
      <RequireAuth>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <Demo />
        </ErrorBoundary>
      </RequireAuth>
    ),
  },
  {
    path: "/archive",
    element: (
    <RequireAuth>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Archive />
      </ErrorBoundary>
    </RequireAuth>
    ),
    loader: archiveLoader,
    errorElement: <ErrorFallback />,
    children: [
      {
        path: "requests/:requestId",
        loader: requestFromIdLoader,
      },
      {
        path: "requests/:requestId/destroy",
        action: destroyRequestAction,
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  }

]);

class App extends Component {
  render() {
    return (
      <div className='App'>
        <RouterProvider router={router} />
      </div>
    );
  }
}

export default App;
